import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  base: '',
  flex: null,
  width: '',
  override: '',
});
